// extracted by mini-css-extract-plugin
export default {"chatFeedWrapper":"ChatsFeed_chatFeedWrapper__Isy2q","chatScroller":"ChatsFeed_chatScroller__Yqf1N"};